import { createReducer } from '@reduxjs/toolkit';
import { preloadedImagesState } from './images.preloaded-state';
import { addImageIdAction } from './images.actions';

export const imagesReducer = createReducer(preloadedImagesState, (builder) =>
  builder.addCase(addImageIdAction, (state, { payload }) => {
    state.items[payload.id] = payload.src;
  }),
);
